import React from 'react';
import PropTypes from 'prop-types';

/**
 * A component for displaying more
 */
function MetaMore({ children }) {
  return <span className="meta__more">{children}</span>;
}

MetaMore.propTypes = {
  /**
   * The nested children
   */
  children: PropTypes.node.isRequired
};

export default MetaMore;
